import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DrillsService } from '@drills/infra';
import { DrillsRouting } from './drills.routing';

@NgModule({
  imports: [RouterModule.forChild(DrillsRouting)],
  providers: [DrillsService]
})
export class DrillsModule {}
